import { render, staticRenderFns } from "./form-component-planner.vue?vue&type=template&id=5055932c"
import script from "./form-component-planner.vue?vue&type=script&lang=ts"
export * from "./form-component-planner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports